import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, ArrowUpRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { COLORS, NAV, PRODUCT, productUrl } from "../../data/catalog";

const ENTRIES = [
  ...COLORS.map((c) => ({ label: `${PRODUCT.name} — ${c.name}`, to: productUrl(c.id), img: c.image, keys: `${c.name} belt bag crossbody ${c.id}` })),
  ...NAV.slice(1).map((n) => ({ label: n.label, to: n.to, keys: n.label })),
];

export const SearchOverlay = ({ open, onOpenChange }) => {
  const [q, setQ] = useState("");
  const nav = useNavigate();
  const res = ENTRIES.filter((e) => `${e.label} ${e.keys}`.toLowerCase().includes(q.trim().toLowerCase()));
  const go = (to) => { onOpenChange(false); setQ(""); nav(to); };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-lenis-prevent className="max-w-2xl gap-0 rounded-none border-line bg-ivory p-0" data-testid="search-overlay">
        <DialogTitle className="sr-only">Search</DialogTitle>
        <div className="flex items-center gap-3 border-b border-line px-6 py-5">
          <Search className="h-5 w-5 text-graphite" />
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search colors, bags, pages…"
            data-testid="search-input" className="w-full bg-transparent font-display text-2xl text-ink outline-none placeholder:text-graphite/70" />
        </div>
        <ul className="max-h-[60vh] overflow-y-auto p-3" data-testid="search-results">
          {res.length === 0 && <li className="p-6 text-sm text-graphite">No results for “{q}”.</li>}
          {res.map((r, i) => (
            <li key={r.to + i}>
              <button onClick={() => go(r.to)} data-testid={`search-result-${i}`} className="group flex w-full items-center gap-4 px-3 py-3 text-left transition-colors hover:bg-stone">
                {r.img ? <img src={r.img} alt="" className="h-12 w-12 bg-white object-contain" /> : <span className="h-12 w-12 bg-stone" />}
                <span className="flex-1 text-sm text-ink">{r.label}</span>
                <ArrowUpRight className="h-4 w-4 text-graphite transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </button>
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
};
